<span aria-hidden="true" class="text-danger">*</span>
<span class="text-danger sr-only">({{'base.required' | transloco}})</span>
